import React, {useState, useEffect} from 'react';
import { AutoCompleteSelect } from '../../autocomplete/select/auto-complete-select';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus} from '@fortawesome/pro-solid-svg-icons';

import { FormularioPessoasModal } from '../cadastro/formulario-pessoas-modal';



const usePessoasSearchInterface = (getApi, tipoPessoa = '') => {

    let [dataStore, setDataStore] = useState({});
    
    useEffect(() => {
        onSearch();
    },[])

    let searchListeners = [];

    const on = (event, callback) => {
        if(event == "search"){
            searchListeners.push(callback)
        }
    }
  
    const onSearch = async (query = '') => {
      const api = await getApi();

      console.log(tipoPessoa);
      
      const result = await api.get("/pessoas/sugestoes", {
                                        params: { 
                                            tipoPessoa,
                                            query
                                        }
                                    });
      const newDataStore = Object.assign(result.data);
      setDataStore(newDataStore);
      for(const listener of searchListeners){
        listener(newDataStore);
      }
      return newDataStore;
      
    }
  
    const onFilter = (query, dataStore) => {
      const keys = Object.keys(dataStore);
      const categorias = [];

      keys.forEach(key => {
        let itensCategoria = [];
        itensCategoria = dataStore[key].filter((pessoa) => {
                return (pessoa.nome.toLowerCase().indexOf(query.toLowerCase()) >= 0 || 
                       (pessoa.nome.documento && pessoa.documento.cpfCnpj.indexOf(query))
                );
            }).map(pessoa => {
                return {
                    value: key + "_" + pessoa.uuid,
                    label: <div >{pessoa.nome}</div>
                }
            });
        if(itensCategoria.length){
            categorias.push({
                label: <span>{key}</span>,
                options: itensCategoria
            })

        }
      })
      
      return categorias
  
    };
  
    
  
    return {dataStore, onSearch, onFilter, on}
  
  
}



const AutoCompletePessoasSelect = ({searchListener = (data)=>{}, searchProps, getApi, autoCompleteProps, inputProps, tipoPessoa = '', onSelect=(q)=>{}, comBotaoAdicionar=false, onAfterSave=()=>{}}) => {
    
    const {dataStore, onSearch, onFilter, on} = usePessoasSearchInterface(getApi, tipoPessoa);

    on('search', searchListener);

    const onSelectHandle = (value) => {
        const splitedValue = value.split("_");
        const tipo = splitedValue[0];
        const itemSelecionado = dataStore[tipo].filter(pessoa => {
            return (pessoa.uuid == splitedValue[1]);
        })[0];

        itemSelecionado.tipoPessoa = tipo;

        onSelect && onSelect(itemSelecionado);
    }

    let btn = null;

    
    if(comBotaoAdicionar){
        btn = <FormularioPessoasModal 
            buttonOpts={{
                text: "",
                icon: <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>,
                type:"dashed",
                size: (inputProps)? inputProps.size || '' : '',
            }}
            tipoPessoa={tipoPessoa}
            onAfterSave={onAfterSave}
            
            getApi={getApi}

            ></FormularioPessoasModal>
    }

    return (
        <AutoCompleteSelect
            autoCompleteProps={autoCompleteProps}
            searchProps={searchProps}
            searchInterface={{dataStore, onSearch, onFilter}}
            onSelect={onSelectHandle}
            auxButtons={btn}
            inputProps={inputProps}
        ></AutoCompleteSelect>
    );
}

export { AutoCompletePessoasSelect }